// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1BVxl","head":"Table_head__3i-Nm","col":"Table_col__1XgMf"};